const normalizeKey = (value = '') => String(value || '')
  .trim()
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '');

const FORCE_NATURAL_WIDTH = new Set([
  // Controles mascarados com largura semântica fixa. `full: true` não agrega
  // capacidade e quebra a composição visual de prefixos, DDI e máscaras.
  'rg',
  'cpf',
  'cnpj',
  'cep',
  'creditcard',
  'phone',
  'date',
  'time',
  'datetime',
  'period',
  'otp',
]);

const FULL_TRUE = new Set([
  'text',
  'email',
  'password',
  'search',
  'url',
  'upload',
  'combo',
  'multilist',
  'treelist',
  'audio',
  'video',
  'textarea',
  'editor',
  'json',
]);

const FULL_FALSE = new Set([
  'rg',
  'cpf',
  'cnpj',
  'cep',
  'creditcard',
  'phone',
  'date',
  'time',
  'datetime',
  'period',
  'color',
  'number',
  'currency',
  'integer',
  'float',
  'spinner',
  'palette',
  'inputgroup',
  'otp',
]);

export const applyFullDefault = (options = {}) => {
  if (!options) {
    return options;
  }

  const key = normalizeKey(options.element || options.type || options.tag || '');

  // Campos mascarados de largura fixa são sempre compactos. A regra antecede
  // a opção explícita para impedir que uma configuração de tela distorça o
  // componente canônico.
  if (FORCE_NATURAL_WIDTH.has(key)) {
    options.full = false;
    return options;
  }

  if (options.full !== undefined) {
    return options;
  }

  if (FULL_TRUE.has(key)) {
    options.full = true;
  } else if (FULL_FALSE.has(key)) {
    options.full = false;
  }

  return options;
};
